import React from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';

export default (props) => {
  return <Dialog actions={[<RaisedButton primary={true} href="/" label="Create an Account" />]} open={true} title="Account access has changed">
    You will need to register for an account to use FishPath. Registering with a known email address will give you access to your previously entered fisheries.
  </Dialog>
}
